import { ServerEnv } from '../sharedTypes/common/misc';

/**
 * Takes in the serverEnv parameter and returns if it is a gov cloud or Il5.
 * Since back and front end both need to know this answer, this common function
 * exists to keep this decision central and not duplicated between the two envs.
 * @param serverEnv
 */
export default function isGovOrIl5EnvCommon(serverEnv?: ServerEnv) {
    if (!serverEnv) {
        return false;
    }

    const normalizedEnv = serverEnv.toLowerCase();
    return normalizedEnv.includes('gov') || normalizedEnv.includes('il5');
}
